export function recordTripEngagement(api, tripId, { eventType, itineraryItemId, email } = {}) {
  if (!tripId) return Promise.resolve();
  return api.post(`/public/trips/${tripId}/engagement`, {
    eventType: eventType || 'proposal_view',
    itineraryItemId,
    email,
  }).catch(() => {});
}
